export default __webpack_public_path__ + "static/media/SV2.7ff4a364.jpeg";